export const ElementsConfig = {
    radioButtonFrequencyConfig: {
        // tslint:disable-next-line:max-line-length
        questionStatement: 'Would you like your income monthly or yearly?',
        isSafetyQuestion: false,
        questionOptions: [
            {
                label: 'Monthly',
                code: 'M',
                defaultValue: false
            },
            {
                label: 'Yearly',
                code: 'Y',
                defaultValue: false
            }
        ],
        infoIconFlag: true,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: ' If you&#39;ll be using this amount to provide income to cover daily expenses, a monthly payment may suit you best.',
            disabledInfoIconTextVisibility: false
        },
        validationMsg: 'Please make a selection',
        disabled: false
    },
    sliderMonthlyFTRPTermConfig: {
        // tslint:disable-next-line:max-line-length
        sliderTitle: 'What term do you want for your plan?',
        sliderTitleVisible: false,
        sliderType: 'Months',
        sliderTypeVisible: true,
        infoIconFlag: false,
        minValue: 0,
        maxValue: 11,
        currentValue: 0,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'You can choose from a minimum of 3 years to a maximum of 25 years. You can only choose whole years online. If you want to agree a mixure of years and months then you will need to call us up to discuss this.',
            disabledInfoIconTextVisibility: false
        },
        validationMsg: 'Please make a selection',
        stepsArray: [],
        unselectedByDefault: true
    },
    radioButtonFTRPFrequencyConfig: {
        // tslint:disable-next-line:max-line-length
        questionStatement: 'Would you like your income monthly or yearly?',
        isSafetyQuestion: false,
        questionOptions: [
            {
                label: 'Monthly',
                code: 'M',
                disable: true,
                defaultValue: false
            },
            {
                label: 'Quarterly',
                code: 'Q',
                disable: true,
                defaultValue: false
            },
            {
                label: 'Half-yearly',
                code: 'H',
                disable: true,
                defaultValue: false
            },
            {
                label: 'Yearly',
                code: 'Y',
                disable: true,
                defaultValue: false
            }
        ],
        infoIconFlag: true,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: ' If you&#39;ll be using this amount to provide income to cover daily expenses, a monthly payment may suit you best.',
            disabledInfoIconTextVisibility: false
        },
        validationMsg: 'Please make a selection',
        disabled: false
    },

    radioButtonAdvanceConfig: {
        // tslint:disable-next-line:max-line-length
        questionStatement: 'Would you like your income to be paid at the start (advance) or at the end (arrears) of the payment period?',
        isSafetyQuestion: false,
        questionOptions: [
            {
                label: 'In advance',
                code: 'A',
                defaultValue: false
            },
            {
                label: 'In arrears',
                code: 'B',
                defaultValue: false
            }
        ],
        infoIconFlag: true,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'If you choose to get income in arrears, we may be able to offer you a higher regular payment. It makes a bigger difference for yearly payments. Note: you won&#39;t see an income payment until the end of the first period.',
            disabledInfoIconTextVisibility: false
        },
        validationMsg: 'Please make a selection',
        disabled: false
    },

    radioButtonAdvanceFTRPConfig: {
        // tslint:disable-next-line:max-line-length
        questionStatement: 'Would you like your income to be paid at the start (advance) or at the end (arrears) of the payment period? ',
        isSafetyQuestion: false,
        questionOptions: [
            {
                label: 'In advance',
                code: 'A',
                defaultValue: false
            },
            {
                label: 'In arrears',
                code: 'B',
                defaultValue: false
            }
        ],
        infoIconFlag: true,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'If you choose to get income in arrears, we may be able to offer you a higher regular payment. It makes a bigger difference for yearly payments. Note: you won&#39;t see an income payment until the end of the first period.',
            disabledInfoIconTextVisibility: false
        },
        validationMsg: 'Please make a selection',
        disabled: false
    },

    radioButtonincraeseincomeConfig: {
        // tslint:disable-next-line:max-line-length
        questionStatement: 'Do you want your income to increase each year?',
        isSafetyQuestion: false,
        questionOptions: [
            {
                label: 'No',
                code: 'N'
            },
            {
                label: 'Fixed %',
                code: 'F'
            },
            {
                label: 'RPI',
                code: 'R'
            }
        ],
        infoIconFlag: true,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'You can get the same income amount for life, but inflation will chip away at the spending power of that income. You could choose instead to make it increase each year. The increase can be at a fixed rate, such as 2% every year, or in step with inflation, measured by the UK&#39;s Retail Price Index (RPI). If you choose to increase your income each year, your income will start at a lower level.',
            disabledInfoIconTextVisibility: false
        },
        validationMsg: 'Please make a selection',
        disabled: false
    },
    radioButtonvalueProtectionConfig: {
        // tslint:disable-next-line:max-line-length
        questionStatement: 'Would you like us to continue making payments from your annuity after you die?',
        isSafetyQuestion: false,
        questionOptions: [
            {
                // Protect the amount used to buy my annuity
                label: 'Yes, pay a lump sum ',
                code: 'Ann'
            },
            {
                // Protect my income
                label: 'Yes, pay an income',
                code: 'Inc'
            },
            {
                label: 'Neither',
                code: 'Ne'
            }
        ],
        infoIconFlag: true,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'Choosing to add a death benefit to your annuity allows us to continue to make payments after you die.<p>If you want to pay a lump sum:</p><p>• Value Protection provides a lump sum to your beneficiary. This happens if you die before you have received some or all of the amount used to purchase your annuity.</p><p>f you want to pay an income:</p><p>•  A Guaranteed Minimum Payment Period ensures that your income continues to pay out for a minimum period. This happens even if you die within that period.</p><p>•  An income for your dependant provides an income for your spouse, civil partner or financial dependant partner. This happens after you die.</p><p>Death benefits aren’t automatically included with your annuity. If you don’t add a death benefit, we’ll stop your income payments when you die. Selecting a death benefit will reduce the amount of income you can receive from your annuity.</p>',
            disabledInfoIconTextVisibility: false
        },
        validationMsg: 'Please make a selection',
        disabled: false
    },
    radioButtonPeriodOfIncomeConfig: {
        // tslint:disable-next-line:max-line-length
        questionStatement: '<strong>Guaranteed Minimum Payment Period:</strong> What is the minimum period for which you would like to guarantee your income is paid?',
        isSafetyQuestion: false,
        questionOptions: [
            {
                label: 'None',
                code: 'N',
                disable: false
            },
            {
                label: 'Whole years',
                code: 'O',
                disable: false
            },
            {
                label: 'Whole term',
                code: 'F',
                disable: false
            }
        ],
        infoIconFlag: true,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'You can choose to guarantee that your income is paid for a minimum period from the date your plan starts. This means that if you die during your chosen period we’ll continue to pay your income to your estate or any other person you specify until the end of this period. If you choose a guarantee period for the full term of your plan then your maturity lump sum will also be paid should you die. Choosing a guarantee period for the full term of your plan also means you are able to cash in or transfer your plan or make partial withdrawals from your maturity lump sum.',
            disabledInfoIconTextVisibility: false
        },
        validationMsg: 'Please make a selection',
        disabled: false
    },
    radioButtonincomeMaturityConfig: {
        // tslint:disable-next-line:max-line-length
        questionStatement: 'Do you want a quote calculated on the yearly income or the maturity value that you\'d like?',
        isSafetyQuestion: false,
        questionOptions: [
            {
                label: 'Yearly income',
                code: 'Y'
            },
            {
                label: 'Maturity value',
                code: 'M'
            }
        ],
        infoIconFlag: true,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'You can choose how you want your income and maturity value to be calculated. You need to decide what is more important to you: the amount of income you&#39;ll receive or the amount of maturity value you want at the end.',
            disabledInfoIconTextVisibility: false
        },
        validationMsg: 'Please make a selection',
        disabled: false
    },

    radioButtontaxfreeCashConfig: {
        // tslint:disable-next-line:max-line-length
        questionStatement: 'How much would you like us to pay you as tax-free cash?',
        questionStatementSingleSource: 'How much tax-free cash would you like?',
        questionStatementFTRPCORP: 'How much tax-free cash would you like to take from your [select] pension pot?',
        isSafetyQuestion: false,
        questionOptions: [
            {
                label: 'None',
                code: 'N'
            },
            {
                label: '%',
                code: 'P'
            },
            {
                label: '£',
                code: 'A'
            }
        ],
        infoIconFlag: true,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'You can get the same income amount for life, but inflation will chip away at the spending power of that income. You could choose instead to make it increase each year. The increase can be at a fixed rate, such as 2% every year, or in step with inflation, measured by the UK&#39;s Retail Price Index (RPI). If you choose to increase your income each year, your income will start at a lower level.',
            disabledInfoIconTextVisibility: false
        },
        validationMsg: 'Please make a selection',
        disabled: false
    },
    radioButtontaxfreeCashOthersConfig: {
        // tslint:disable-next-line:max-line-length
        questionStatement: 'How much tax-free cash would you like your other provider to pay?',
        isSafetyQuestion: false,
        questionOptions: [
            {
                label: 'None',
                code: 'N'
            },
            {
                label: '%',
                code: 'P'
            },
            {
                label: '£',
                code: 'A'
            }
        ],
        infoIconFlag: true,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'You can get the same income amount for life, but inflation will chip away at the spending power of that income. You could choose instead to make it increase each year. The increase can be at a fixed rate, such as 2% every year, or in step with inflation, measured by the UK&#39;s Retail Price Index (RPI). If you choose to increase your income each year, your income will start at a lower level.',
            disabledInfoIconTextVisibility: false
        },
        validationMsg: 'Please make a selection',
        disabled: false
    },
    sliderperiodOfIncomeConfig: {
        // tslint:disable-next-line:max-line-length
        sliderTitle: '<strong>Guaranteed Minimum Payment Period:</strong> What is the minimum period for which you would like to guarantee your income is paid?',
        sliderTitleVisible: true,
        sliderType: 'Years',
        sliderTypeVisible: true,
        infoIconFlag: true,
        minValue: 0,
        maxValue: 30,
        currentValue: 3,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'You can choose to guarantee your income is paid for a minimum period from the date your annuity starts.<p>If you die during your chosen period,  we’ll keep paying your income until the end of that period. Either to your estate or any other person you specify.</p>',
            disabledInfoIconTextVisibility: false
        },
        validationMsg: 'Please make a selection',
        customErrorMessage: 'Select either no guarantee or a full term guarantee since no income is payable',
        stepsArray: [],
        unselectedByDefault: true

    },
    sliderIncomePercentageConfig: {
        // tslint:disable-next-line:max-line-length
        sliderTitle: 'What percentage of your income would you like us to pay to your spouse/registered civil partner or qualifying partner when you die?',
        sliderTitleVisible: true,
        sliderType: 'Percentage',
        sliderTypeVisible: true,
        infoIconFlag: true,
        minValue: 0,
        maxValue: 100,
        currentValue: 0,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'We can pay an income to your surviving partner for the rest of their life - a &#39;joint life&#39; annuity. If you&#39;re just adding this now, we&#39;ll need to send you a few steps back to answer some questions about your partner&#39;s health. If you choose not to add your partner, they won&#39;t get an income after you die. There are other ways to protect them if you were to die early - see the other two protection choices we offer.',
            disabledInfoIconTextVisibility: false,
            // tslint:disable-next-line:max-line-length
            disabledInfoIconTextPartA: "This option isn’t available as you didn’t select a dependant. If you’d like to add a dependant please ",
            disabledInfoIconTextPartB: "go back to Your dependant’s page."
        },
        validationMsg: 'Please make a selection',
        zeroValidationMsg: 'By choosing 0% you are opting out of this benefit',
        stepsArray: [{ value: 0 },
        { value: 50 },
        { value: 67 },
        { value: 100 }],
        unselectedByDefault: true
    },
    sliderTaxfreeLumpsumConfig: {
        // tslint:disable-next-line:max-line-length
        sliderTitle: 'How much would you like us to pay you as tax-free cash?',
        sliderTitleVisible: false,
        sliderType: 'Price',
        sliderTypeVisible: true,
        infoIconFlag: false,
        minValue: 0,
        maxValue: 25,
        currentValue: 10,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'You can normally take up to 25% of your pension pot as a tax-free cash sum. Taking money from your pension pot will reduce what’s left to buy an income.',
            disabledInfoIconTextVisibility: false
        },
        validationMsg: 'Please make a selection',
        invalidLTAMinMsg: 'The minimum pension pot required after tax-free cash is £[LTAMin]',
        stepsArray: [],
        unselectedByDefault: true
    },
    sliderincreaseIncomeConfig: {
        // tslint:disable-next-line:max-line-length
        sliderTitle: '',
        sliderTitleVisible: false,
        sliderType: 'Percentage',
        sliderTypeVisible: false,
        infoIconFlag: false,
        minValue: 1,
        maxValue: 5,
        currentValue: 1,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'The company your pensions savings are with will send you details of all your retirement options when you are four to six months from your retirement date. If you haven’t received this, we strongly urge you to contact them and read through the information before deciding what you want to do.',
            disabledInfoIconTextVisibility: false
        },
        validationMsg: 'Please make a selection',
        stepsArray: [],
        unselectedByDefault: false
    },
    sliderTermConfig: {
        // tslint:disable-next-line:max-line-length
        sliderTitle: 'What term do you want for your plan?',
        sliderTitleVisible: true,
        sliderType: 'Years',
        sliderTypeVisible: true,
        infoIconFlag: true,
        minValue: 3,
        maxValue: 25,
        currentValue: 3,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'You can choose from a minimum of 3 years to a maximum of 25 years. You can only choose whole years online. If you want to agree a mixure of years and months then you will need to call us up to discuss this.',
            disabledInfoIconTextVisibility: false
        },
        validationMsg: 'Please make a selection',
        stepsArray: [],
        unselectedByDefault: true
    },
    buttonConfig: {
        type: 'button',
        values: '',
        name: 'next',
        label: 'Next',
        readonly: false,
        controlName: 'next',
        borderRequired: false,
        required: true,
        classType: 'btn-cta',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    dependantDetailDob: {
        type: 'textBox',
        value: '',
        name: 'dateOfBirth',
        label: 'Date of birth',
        readonly: false,
        controlName: 'dateOfBirth',
        controlWidth: 150,
        borderRequired: false,
        required: true,
        placeHolder: 'DD / MM / YYYY',
        errorMessage: 'Please enter a date of birth',
        errorMessageInvalidDate: 'Please enter a valid date',
        errorMessageInvalidFormat: 'Please enter a date in format DD/MM/YYYY',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    depandantDetailGenderConfig: {
        type: 'dropdown',
        options: [
            { value: 'Male', code: 'M' },
            { value: 'Female', code: 'F' }
        ],
        defaultValue: null,
        name: 'gender',
        label: 'Gender',
        errorMessage: 'Please select a gender',
        readonly: false,
        controlName: 'gender',
        borderRequired: false,
        required: true,
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },

    sourcesListCvt: [
        { value: 'Legal & General', code: 'Int.', controlName: 'internal',fundProvider: 'I' },
        { value: 'Aegon', code: 'CDF', controlName: 'aegon', productCodeValidationRule: /^[0-9]{2}[t]?$/i,fundProvider: 'H' },
        /*{ value: 'DDP1',code: 'CDF', controlName: 'ddp1',fundProvider:'M'},
        { value: 'DDP2',code: 'CDF', controlName: 'ddp2',fundProvider:'N'},
        { value: 'DDP3',code: 'CDF', controlName: 'ddp3',fundProvider:'O'},
        { value: 'DDP4',code: 'CDF', controlName: 'ddp4',fundProvider:'P'},*/
        { value: 'PensionBee',code: 'CDF', controlName: 'pensionBee',fundProvider:'L'},
        { value: 'Aon',code: 'CDF', controlName: 'aon',fundProvider:'M'},
        { value: 'Sun Life Financial of Canada', code: 'CDF', controlName: 'sunLife', productCodeValidationRule: /^[0]$/i,fundProvider: 'F' },
        { value: 'Phoenix Life', code: 'CDF', controlName: 'phoenixLife', productCodeValidationRule: /^[0]$/i,fundProvider: 'O' },
        { value: 'ReAssure', code: 'CDF', controlName: 'reAssure',fundProvider: 'J' }, 
        { value: 'HSBC', code:'CDF', controlName:'hsbc',fundProvider: 'R' }, 
        { value: 'Other', code: 'Ext', controlName: 'external',fundProvider: 'Ext' }

        
    ],

    fundAttributes: [
        'fundValue', 'transferType', 'productCode'
    ],

    fundValueConfig: {
        type: 'currency',
        value: '',
        name: 'fundValue',
        readonly: false,
        controlName: 'fundValue',
        required: true,
        placeHolder: '',
        errorMessage: 'Please make a selection',
        customErrorMessage1: 'If you don’t require a maturity value, please select the Cash-Out Retirement Plan',
        minValue: '0.00',
        maxValue: '99999999.99',
        infoIconData: {
            // tslint:disable-next-line:max-line-length
            content: 'If you choose yearly income then we will calculate your maturity value based on the money that is left over. If you choose maturity value, then we will calculate this and the remaining money will be used to calculate your income.',
            disabledInfoIconTextVisibility: false
        },
        infoIconFlag: true
    },

    productCodeConfig: {
        type: 'textBox',
        value: '',
        name: 'productCode',
        label: 'First Name',
        readonly: false,
        controlName: 'productCode',
        borderRequired: false,
        required: true,
        placeHolder: 'Please enter',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        },
        validationRule: /^[0-9]{2}[a-z]$/i
    },
    dependantDetailTitleInformation: {
        label: '',
        // tslint:disable-next-line:max-line-length
        content: 'Our Pension Annuity lets you nominate your surviving partner for an income for life, from your pension savings. This will be your spouse, civil partner or another financially-dependent partner. If this excludes someone you need to take care of in the event of your death, you may choose a different kind of protection for them, in a few moments.'
    },
    cardConfig: {
        maxLimit: 6
    },
    buttonEditCalculateConfig: {
        type: 'button',
        values: '',
        name: 'editcalculate',
        label: 'Edit calculation',
        readonly: false,
        controlName: 'next',
        borderRequired: false,
        required: true,
        classType: '',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    buttonDoneEditConfig: {
        type: 'button',
        values: '',
        name: 'doneedit',
        label: 'Done editing',
        readonly: false,
        controlName: 'next',
        borderRequired: false,
        required: true,
        classType: '',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    buttonChooseConfig: {
        type: 'button',
        values: '',
        name: 'choose',
        label: 'Choose',
        readonly: false,
        controlName: 'next',
        borderRequired: false,
        required: true,
        classType: '',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    buttonAddCalculationConfig: {
        type: 'button',
        values: '',
        name: 'next',
        label: 'Next',
        readonly: false,
        controlName: 'next',
        borderRequired: false,
        required: true,
        classType: 'btn-cta',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        },
        showIcon: true,
        iconClass: ''
    },
    slidervpConfig: {
        // tslint:disable-next-line:max-line-length
        sliderTitle: '<strong>Value Protection:</strong> What percentage of the amount used to buy your annuity would you like to protect as a lump sum?',
        sliderTitleVisible: true,
        sliderType: 'Percentage',
        sliderTypeVisible: true,
        infoIconFlag: true,
        minValue: 25,
        maxValue: 100,
        currentValue: 25,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'You can ensure you\'re paid all or some of the value of the lump sum you used to buy your annuity. If you were to die before you had, we would pay out a lump sum of 25%, 50%, 75% or 100% of the original amount, minus any income you\'ve already had. There would be no further income for your qualifying partner.',
            disabledInfoIconTextVisibility: false,
            // tslint:disable-next-line:max-line-length
            disabledInfoIconTextPartA: "This option isn’t available, as you have selected a dependant"

        },
        validationMsg: 'Please make a selection',
        stepsArray: [{ value: 25 },
        { value: 50 },
        { value: 75 },
        { value: 100 }],
        unselectedByDefault: true
    },
    postCodeConfig: {
        type: 'textBox',
        defaultValue: '',
        name: 'postcode',
        labelText: 'Post code',
        controlName: 'postcode',
        readonly: false,
        controlWidth: 150,
        borderRequired: false,
        required: true,
        errorMessage: 'Please enter a post code',
        errorMessageInvalid: 'Please enter a valid UK post code',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    contryConfig: {
        type: 'dropdown',
        options: [
            { value: 'UNITED KINGDOM', code: 'UNITED KINGDOM' },
            { value: 'USA', code: 'USA' }
        ],
        defaultValue: null,
        name: 'country',
        label: 'Country',
        errorMessage: 'Please select a country',
        readonly: false,
        controlName: 'country',
        borderRequired: false,
        required: true,
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    sliderMonthlyTermConfig: {
        // tslint:disable-next-line:max-line-length
        sliderTitle: 'What term do you want for your plan?',
        sliderTitleVisible: false,
        sliderType: 'Months',
        sliderTypeVisible: true,
        infoIconFlag: false,
        minValue: 0,
        maxValue: 11,
        currentValue: 0,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'You can choose from a minimum of 3 years to a maximum of 25 years. You can only choose whole years online. If you want to agree a mixure of years and months then you will need to call us up to discuss this.',
            disabledInfoIconTextVisibility: false
        },
        validationMsg: 'Please make a selection',
        stepsArray: [],
        unselectedByDefault: true
    },
    radioButtonCORPFrequencyConfig: {
        // tslint:disable-next-line:max-line-length
        questionStatement: 'How often would you like your income paid?',
        isSafetyQuestion: false,
        questionOptions: [
            {
                label: 'Monthly',
                code: 'M',
                disable: true,
                defaultValue: false
            },
            {
                label: 'Quarterly',
                code: 'Q',
                disable: true,
                defaultValue: false
            },
            {
                label: 'Half-yearly',
                code: 'H',
                disable: true,
                defaultValue: false
            },
            {
                label: 'Yearly',
                code: 'Y',
                disable: true,
                defaultValue: false
            }
        ],
        infoIconFlag: true,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: ' If you&#39;ll be using this amount to provide income to cover daily expenses, a monthly payment may suit you best.',
            disabledInfoIconTextVisibility: false
        },
        validationMsg: 'Please make a selection',
        disabled: true
    },
    taxfreeValueConfig: {
        type: 'currency',
        value: '',
        name: 'fundValueTaxfree',
        readonly: false,
        controlName: 'fundValueTaxfree',
        required: true,
        placeHolder: '',
        errorMessage: 'Please make a selection',
        invalidTaxfreeMessage: 'Selected tax-free cash exceeds 25% of [dealpartner] policy fund',
        invalidLTAMinMsg: 'The minimum pension pot required after tax-free cash is £[LTAMin]',
        minValue: '0.00',
        maxValue: '99999999.99',
        infoIconData: {
            // tslint:disable-next-line:max-line-length
            content: 'This is the amount you take as an up-front lump sum, with no tax to pay. The maximum is normally 25% of the pot. Check with your existing savings scheme to make sure you\'re taking it out at the right point. Taking money from your fund will reduce what\'s left to buy an income for your retirement. We strongly recommend you seek financial guidance before making these decisions.',
            disabledInfoIconTextVisibility: false
        },
        infoIconFlag: false,
        title: true,
        titleValue: '0'
    },
    secondaryTaxfreeValueConfig: {
        type: 'currency',
        value: '',
        name: 'fundValueTaxfreeSecondary',
        readonly: false,
        controlName: 'fundValueTaxfreeSecondary',
        required: true,
        placeHolder: '',
        errorMessage: 'Please make a selection',
        invalidTaxfreeMessage: 'Selected tax-free cash exceeds 25% of [dealpartner] policy fund',
        invalidLTAMinMsg: 'The minimum pension pot required after tax-free cash is £[LTAMin]',
        minValue: '0.00',
        maxValue: '99999999.99',
        infoIconData: {
            // tslint:disable-next-line:max-line-length
            content: 'This is the amount you take as an up-front lump sum, with no tax to pay. The maximum is normally 25% of the pot. Check with your existing savings scheme to make sure you\'re taking it out at the right point. Taking money from your fund will reduce what\'s left to buy an income for your retirement. We strongly recommend you seek financial guidance before making these decisions.',
            disabledInfoIconTextVisibility: false
        },
        infoIconFlag: false,
        title: true,
        titleValue: '0'
    },
    sliderTaxfreeLumpsumConfigSecondary: {
        // tslint:disable-next-line:max-line-length
        sliderTitle: 'How much would you like us to pay you as tax-free cash?',
        sliderTitleVisible: false,
        sliderType: 'Price',
        sliderTypeVisible: true,
        infoIconFlag: false,
        minValue: 0,
        maxValue: 25,
        currentValue: 10,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'You can normally take up to 25% of your pension pot as a tax-free cash sum. Taking money from your pension pot will reduce what’s left to buy an income.',
            disabledInfoIconTextVisibility: false
        },
        validationMsg: 'Please make a selection',
        invalidLTAMinMsg: 'The minimum pension pot required after tax-free cash is £[LTAMin]',
        stepsArray: [],
        unselectedByDefault: true
    },
    startDate: {
        type: 'textBox',
        value: '',
        name: 'startDate',
        label: 'Date',
        readonly: false,
        controlName: 'startDate',
        controlWidth: 150,
        borderRequired: false,
        required: true,
        placeHolder: 'DD / MM / YYYY',
        errorMessage: 'Please enter a start date',
        errorMessageInvalidDate: 'Please enter a valid date',
        errorMessageInvalidFormat: 'Please enter a date in format DD/MM/YYYY',
        StartDateAge55Error: 'You must be at least 55 years old at the start date of your plan',
        StartDateThreeMonthsError: 'Please select a date within 3 months of today\'s date',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    radioButtonStartDateConfig: {
        // tslint:disable-next-line:max-line-length
        questionStatement: 'When would you like your plan to start?',
        isSafetyQuestion: false,
        questionOptions: [
            {
                label: 'As soon as possible',
                code: 'A'
            }
        ],
        infoIconFlag: true,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'The furthest date in the future we can start your plan is 3 months from today. If you do not want to choose a specific start date then please select \'as soon as possible\'. Your plan starts as soon as we have received all the funds from your pension pots, and any other supporting information.',
            disabledInfoIconTextVisibility: false
        },
        validationMsg: 'Please enter a start date',
        disabled: false
    }
};
